var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.9993C2 11.9993 5.63636 4.72656 12 4.72656C18.3636 4.72656 22 11.9993 22 11.9993C22 11.9993 18.3636 19.272 12 19.272C5.63636 19.272 2 11.9993 2 11.9993Z",
    stroke: "#979797",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.728C13.5062 14.728 14.7273 13.5069 14.7273 12.0007C14.7273 10.4945 13.5062 9.27344 12 9.27344C10.4937 9.27344 9.27271 10.4945 9.27271 12.0007C9.27271 13.5069 10.4937 14.728 12 14.728Z",
    stroke: "#979797",
    strokeWidth: 1.81818,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.4f2a7c1ea6f6689542f30361ddb521ea.svg";
export { ForwardRef as ReactComponent };